
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.993 3.507C4.595.323.778 1.066.75 4.755c0 2.034 1.832 2.805 3.076 3.604a5.96 5.96 0 012.181 2.329 6.6 6.6 0 012.167-2.343c1.216-.855 3.09-1.57 3.076-3.604-.028-3.717-3.957-4.362-5.257-1.234z","fill":"#c60000"}})])
          )
        }
      }
    